import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateUserNotificationReadStateRequestParams {
  ids: string[];
  readState: boolean;
}

export class UpdateUserNotificationReadStateRequest extends Request<IUpdateUserNotificationReadStateRequestParams, {}> {
  constructor(params: IUpdateUserNotificationReadStateRequestParams) {
    super('updateNotificationsReadStateForUser', params);
  }
}